import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuthService } from './auth.service';

// URLs that are not worth returning to after login.
const NO_RETURN_URLS = ['/', '/groups', '/login'];

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    return true;
  } else {
    // Remember the deep link; ListGroupsComponent sends the user back to it after login.
    if (!NO_RETURN_URLS.includes(state.url)) {
      try {
        localStorage.setItem('redirectAfterLogin', state.url);
      } catch (error) {
        logger.warn('auth.guard.ts :: Could not store return URL:', { url: state.url, error });
      }
    }
    logger.debug('auth.guard.ts :: Not authenticated, sending to login:', { url: state.url });
    router.navigate(['auth/login']);
    return false;
  }
};
